import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { useTheme } from 'styled-components';
import { HeaderContainer, HeaderHeight, HeaderWrapper } from './styleComponents';

const MillelacsLevelUpText = () => {
  const { FavouritesInformation } = useTheme();

  return (
    <>
      <HeaderWrapper>
        <HeaderContainer>
          <div style={FavouritesInformation.LevelUpText} className="levelUpTitle">
            {getText(TEXT_KEY.LEVEL_UP_TEXT)}
          </div>
        </HeaderContainer>
      </HeaderWrapper>
      <HeaderHeight />
    </>
  );
};

export default MillelacsLevelUpText;

